<div class="login-form-container">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form">
      <div class="form__container">
        <atom-input
          class="form__container__input"
          placeholder="Usuario"
          type="text"
          formControlName="username"
          [inputBackgroundColor]="'unset'"
          [inputTextColor]="'#f0f0f0'"
          [borderColor]="'#f0f0f0'"
        ></atom-input>
        <atom-label class="error-message" *ngIf="isValidField('username')" [text]="getFieldError('username')"></atom-label>
      </div>

      <div class="form__container">
        <atom-input
          class="form__container__input"
          placeholder="Contraseña"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          [inputBackgroundColor]="'unset'"
          [inputTextColor]="'#f0f0f0'"
          [borderColor]="'#f0f0f0'"
          [buttonColor]="'#16726b'"
          [isPasswordField]="true"
          [passwordIcon]="showPassword ? 'visibility' : 'visibility_off'"
          (togglePassword)="onTogglePassword()"
        ></atom-input>
        <atom-label class="error-message" *ngIf="isValidField('password')" [text]="getFieldError('password')"></atom-label>
      </div>

      <!-- <atom-link href="/recuperar-contraseña" label="¿Olvidaste tu contraseña?" class="form__link"></atom-link> -->
      <atom-button class="form__button" [label]="'Entrar'" [type]="'submit'"></atom-button>
  </form>
</div>
